import { notifications, type NotificationData } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons-react";
import i18n from "#/i18n";

export const showSuccessNotification = ({
  title,
  ...props
}: NotificationData) => {
  notifications.show({
    title: title ?? i18n.t("common.success"),
    color: "green",
    icon: <IconCheck size={16} />,
    className: "border-l-6 border-l-green-500 my-2",
    ...props,
  });
};

export const showErrorNotification = ({
  title,
  ...props
}: NotificationData) => {
  notifications.show({
    title: title ?? i18n.t("common.error"),
    color: "red",
    icon: <IconX size={16} />,
    className: "border-l-6 border-l-red-500 my-2",
    ...props,
  });
};
